import App from "./App";

export default App;
export { default as AppAxiosInterceptor } from './AppAxiosInterceptor';
